module.exports = __webpack_public_path__ + "img/r3.9f938804.jpg";